import { FC, HTMLAttributes } from 'react';
import { cn } from '../../../../helpers';
import { tradingSectionClasses } from '../trading-section.constants';

type TradingSectionBodyProps = HTMLAttributes<HTMLDivElement>;

export const TradingSectionBody: FC<TradingSectionBodyProps> = ({
  className,
  children,
  ...rest
}) => (
  <div
    className={cn(tradingSectionClasses.body, 'flex-1 overflow-y-auto p-2', className)}
    {...rest}
  >
    {children}
  </div>
);
